import { useQuery } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { GetActivatedOtpSecretDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { twoFactorAuthModalState } from '~/state/layouts/SharedAppShell/atoms';

export const useFetchOtpSecret = () => {
  const [{ isOpen }, setTwoFactorAuthModalState] = useAtom(twoFactorAuthModalState);

  const { loading, data } = useQuery(GetActivatedOtpSecretDocument, {
    skip: !isOpen,
    nextFetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!data) return;
    if (getMe(data)?.otpSecret) {
      setTwoFactorAuthModalState((_state) => ({ ..._state, currentPanel: 'activating' }));
    }
  }, [data, setTwoFactorAuthModalState]);

  return { loading };
};
